<iwt-estatecloud-main-layout>
  <div>
    <div class="mb-4 flex bg-gray-100 rounded-2xl border p-4">
      <empro-icon
        [name]="'chevron-left'"
        [solid]="true"
        [variant]="'secondary'"
        [defaultSize]="false"
        [size]="'small'"
        class="cursor-pointer w-6 h-6 mr-4"
        (click)="back()"
        (keydown)="back()"
      />

      @if (
        currentView === CommonCustomerView.VIEW && !isLoading && showEditButton
      ) {
        <empro-icon
          [name]="'pencil-square'"
          [solid]="false"
          [variant]="'secondary'"
          [defaultSize]="false"
          [size]="'small'"
          class="cursor-pointer w-6 h-6"
          (click)="currentView = CommonCustomerView.EDIT"
          (keydown)="currentView = CommonCustomerView.EDIT"
        />
      }
      @if (currentView === CommonCustomerView.EDIT) {
        <empro-icon
          [name]="'pencil-square'"
          [solid]="false"
          [variant]="'secondary'"
          [defaultSize]="false"
          [size]="'small'"
          class="cursor-pointer w-6 h-6"
          (click)="currentView = CommonCustomerView.VIEW"
          (keydown)="currentView = CommonCustomerView.VIEW"
        />
      }
      @if (currentView === CommonCustomerView.VIEW && showDeleteAccountButton) {
        <empro-icon
          [name]="'trash'"
          [solid]="false"
          [variant]="'secondary'"
          [defaultSize]="false"
          [size]="'small'"
          class="cursor-pointer w-6 h-6"
          (click)="showDeleteModal()"
          (keydown)="showDeleteModal()"
        />
      }

      <p class="ml-4" [title]="customer?.companyName">
        {{ truncateString(customer?.companyName) }}
      </p>
    </div>

    <iwt-estatecloud-common-customer
      *ngIf="currentView !== CommonCustomerView.VIEW"
      [(isLoading)]="isLoading"
      [showForm]="showForm"
      [errorMessage]="errorMessage"
      [customer]="customer"
      [view]="currentView"
      (cancelAction)="currentView = CommonCustomerView.VIEW"
      (updateAction)="customer = $event"
    />

    <!-- currentView === "VIEW" detail page -->
    @if (currentView === CommonCustomerView.VIEW) {
      <div class="relative">
        <empro-spinner [show]="isLoading" />
        <div
          class="p-4 bg-white rounded-2xl border grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
        >
          <empro-alert-box
            *ngIf="errorMessage.show"
            class="w-full col-span-4"
            [header]="'Error'"
            [message]="errorMessage.message"
            [variant]="'error'"
          />
          <div class="relative" *ngIf="customer?.tenantUuid">
            <p class="text-sm text-gray-500">TenantUuid</p>
            <p class="text-sm flex items-center justify-between break-words">
              <span
                (click)="copyToClipboard(customer?.tenantUuid)"
                (keydown)="onKeyDown($event)"
              >
                {{ customer?.tenantUuid }}
              </span>
            </p>
          </div>
          <div class="relative" *ngIf="customer?.serviceVersion">
            <p class="text-sm text-gray-500">ServiceVersion</p>
            <p class="text-sm flex items-center justify-between break-words">
              {{ customer?.serviceVersion }}
            </p>
          </div>
          <div class="relative" *ngIf="customer?.contractId">
            <p class="text-sm text-gray-500">Kundennummer</p>
            <p class="text-sm flex items-center justify-between break-words">
              <span
                (click)="copyToClipboard(customer?.contractId)"
                (keydown)="onKeyDown($event)"
              >
                {{ customer?.contractId }}
              </span>
            </p>
          </div>
          <div class="relative" *ngIf="customer?.customerId">
            <p class="text-sm text-gray-500">LizenzierungsID</p>
            <p class="text-sm flex items-center justify-between break-words">
              <span
                (click)="copyToClipboard(customer?.customerId)"
                (keydown)="onKeyDown($event)"
              >
                {{ customer?.customerId }}
              </span>
            </p>
          </div>
          @if (customer?.licenseCount) {
            <div class="relative">
              <p class="text-sm text-gray-500">Lizenzanzahl</p>
              <p class="text-sm flex items-center justify-between break-words">
                {{ customer?.licenseCount }}
              </p>
            </div>
          }
          @if (customer?.companyName) {
            <div class="relative">
              <p class="text-sm text-gray-500">Firmenname</p>
              <p class="text-sm flex items-center justify-between break-words">
                <span
                  (click)="copyToClipboard(customer?.companyName)"
                  (keydown)="onKeyDown($event)"
                >
                  {{ customer?.companyName }}
                </span>
              </p>
            </div>
          }
          @if (customer?.edition) {
            <div class="relative">
              <p class="text-sm text-gray-500">Edition</p>
              <p class="text-sm flex items-center justify-between break-words">
                {{ customer?.edition }}
              </p>
            </div>
          }
          @if (customer?.editionConfig) {
            <div class="relative">
              <p class="text-sm text-gray-500">EditionConfig</p>
              <p class="text-sm flex items-center justify-between break-words">
                {{ customer?.editionConfig }}
              </p>
            </div>
          }
          @if (customer?.isDomestic) {
            <div class="relative">
              <p class="text-sm text-gray-500">Testaccount</p>
              <p class="text-sm flex items-center justify-between break-words">
                {{ customer?.isDomestic }}
              </p>
            </div>
          }
        </div>
      </div>
    }
    @if (migrationStatusResponse?.timestamp) {
      <div
        class="p-4 mt-2 bg-white rounded-2xl border grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 lg:grid-cols-5 gap-4"
      >
        @if (customer?.tenantUuid) {
          <div class="relative">
            <p class="text-sm text-gray-500">Migration Quelle</p>
            <p class="text-sm flex items-center justify-between break-words">
              {{ migrationStatusResponse?.migrationType }}
            </p>
          </div>
          <div class="relative">
            <p class="text-sm text-gray-500">Migration gestartet</p>
            <p class="text-sm flex items-center justify-between break-words">
              {{
                migrationStatusResponse?.timestamp | date: 'dd.MM.yyyy HH:mm'
              }}
            </p>
          </div>
          <div class="relative">
            <p class="text-sm text-gray-500">Migration beended</p>
            <p class="text-sm flex items-center justify-between break-words">
              {{
                migrationStatusResponse?.statusTimestamp
                  | date: 'dd.MM.yyyy HH:mm'
              }}
            </p>
          </div>
          <div class="relative">
            <p class="text-sm text-gray-500">Status</p>
            <div class="w-20">
              <empro-shared-badge
                [variant]="getBadgeVariant()"
                [hover]="false"
                [hasBorder]="false"
                [rounded]="16"
                size="small"
                shadow="small"
              >
                {{ migrationStatusResponse?.executionStatus }}
              </empro-shared-badge>
            </div>
          </div>
        }
        <div class="w-full relative">
          <empro-button
            class="absolute inset-y-0 right-0 font-medium"
            [isLoading]="isLoading"
            [disabled]="migrationStatusResponse?.executionStatus !== 'SUCCESS'"
            [fill]="'outline'"
            size="small"
            [hidden]="isLoading"
            (click)="deleteSupportUserClick()"
            (keydown)="onKeyDown($event)"
          >
            <empro-typography type="small" weight="bold">
              Zugangsdaten an Kunden versenden
            </empro-typography>
          </empro-button>
        </div>
      </div>
    }

    @if (customer?.customerId && customer?.tenantUuid) {
      <iwt-estatecloud-tenant-export [customerId]="customer!.customerId" />
    }

    <iwt-estatecloud-list-user
      [users]="users"
      [tenantUuid]="customer?.tenantUuid"
    />
  </div>

  <empro-modal
    [open]="openDeleteAccountModal"
    [hasClose]="true"
    [closeOutside]="false"
    (onClose)="closeModal()"
    sizeY="large"
  >
    <div class="content" content>
      <div modalTitle>
        <empro-typography class="title" type="large" weight="medium">
          Kunde löschen
        </empro-typography>
      </div>

      <div modalContent class="text-left" [ngClass]="'h-full'">
        <div class="mt-4">
          <div>
            <empro-typography title>
              <p>
                <span class="default-styling">
                  Bis du sicher, dass der Account
                  {{ this.customer?.companyName?.substring(0, 50) }} gelöscht
                  werden soll?
                </span>
              </p>
            </empro-typography>
          </div>
          <br />
          <hr />
          <div
            class="flex justify-center items-center gap-x-10 mt-6"
            modalFooter
          >
            <empro-button
              variant="secondary"
              (onClick)="closeModal('delete')"
              fill="solid"
              class="font-medium"
            >
              Löschen
            </empro-button>
            <empro-button
              variant="primary"
              (onClick)="closeModal()"
              fill="solid"
              class="font-medium"
            >
              Abbrechen
            </empro-button>
          </div>
        </div>
      </div>
    </div>
  </empro-modal>
</iwt-estatecloud-main-layout>
